import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
import { SectionHeader } from '../components/SectionHeader';
import { OperationsCard } from '../components/OperationsCard';
import { UseCaseAccordion } from '../components/UseCaseAccordion';
import { LimeBandCTA } from '../components/LimeBandCTA';
export function Perspective() {
  const accordionItems = [{
    title: 'Empower Employees',
    content: "From return-to-office shifts and reorgs to new leadership and moments of recognition. See what's strengthening belief, and what's eroding it, so people can show up at their best.",
    cta: "→ Let's strengthen your culture",
    ctaHref: 'mailto:chat@hiddenmatter.ai'
  }, {
    title: 'Cultivate Customers',
    content: "Whether it's onboarding, pricing updates, product launches, or service hiccups. Spot what's fueling loyalty, and what's putting it on the line.",
    cta: "→ Let's tune into your market",
    ctaHref: 'mailto:chat@hiddenmatter.ai'
  }, {
    title: 'Support Partners',
    content: "Changing SLAs, new policies, procurement rollouts, shifting scope. Know exactly where friction is building (or where momentum's mounting) so partnerships stay strong.",
    cta: "→ Let's elevate your ecosystem",
    ctaHref: 'mailto:chat@hiddenmatter.ai'
  }, {
    title: 'Productize Perspective',
    content: 'AI is changing what customers, investors and boards expect, and fast. Many teams feel the pressure to evolve their offerings but lack the time, skills, or bandwidth to build AI-driven solutions themselves. Huwey can close the gap, giving you a ready-made intelligence layer you can make your own.',
    cta: "→ Let's partner",
    ctaHref: 'mailto:chat@hiddenmatter.ai'
  }];
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-319">
      <Navbar data-id="element-320" />
      <main className="flex-grow" data-id="element-321">
        {/* Hero Section */}
        <Section className="pt-32 md:pt-48" data-id="element-322">
          <div className="flex flex-col md:flex-row md:gap-16 lg:gap-32" data-id="element-323">
            <div className="mb-8 md:mb-0 md:w-1/2" data-id="element-324">
              <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black leading-tight mb-6" data-id="element-325">
                What to fix, where it counts.
              </h1>
              <div className="space-y-4" data-id="element-326">
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-327">
                  No one starts a new job thinking, "I can't wait to give this
                  60%." That happens over time.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-328">
                  Not because people don't care, but because things wear them
                  down. Misalignment. Broken promises. Unmet expectations.
                  Feeling unheard. Things bagel Tuesdays and meeting-free
                  Fridays don't fix.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-329">
                  People want to do the job they were hired to do and do it
                  well. When it gets too hard, effort drops. Or worse, people
                  do.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-330">
                  That's why the question shouldn't be "How do we improve
                  engagement?" It should be, "How do we improve performance?"
                  Because when you fix what holds people back, you don't just
                  lift engagement in the moment, you build resilience for the
                  long haul.
                </p>
              </div>
            </div>
            <div className="md:w-1/2 overflow-hidden rounded-lg bg-lightgray flex items-center justify-center aspect-[4/3]" data-id="element-331">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ttbEThEKDHKzjYR3hrJrJ8/Perspective_Image_1.jpg" alt="Silhouettes in modern architectural space with tall windows" className="w-full h-full object-cover" data-id="element-332" />
            </div>
          </div>
        </Section>
        {/* Opportunity Section */}
        <Section data-id="element-333">
          <div className="max-w-4xl mx-auto text-center" data-id="element-334">
            <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-335">
              Your business is talking. Are you really listening?
            </h2>
            <div className="space-y-4" data-id="element-336">
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-337">
                Every day, your employees are giving you clues. Through surveys,
                interviews, and conversations. But most of that feedback is hard
                to organize, harder to interpret, and easy to ignore.
              </p>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-338">
                So, leaders end up making decisions based on the loudest voices,
                the latest fire drills, or the programs that worked in the past.
                Meanwhile, the real issues, the ones affecting belief, behavior,
                and performance, go unresolved.
              </p>
            </div>
          </div>
        </Section>
        {/* Tool Section */}
        <Section bgColor="lightgray" data-id="element-339">
          <div className="flex flex-col md:flex-row md:gap-16 lg:gap-32" data-id="element-340">
            <div className="mb-8 md:mb-0 md:w-1/2 bg-white overflow-hidden rounded-lg flex items-center justify-center aspect-[4/3]" data-id="element-341">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/syKhiFZ1EiDEiQ1z9nxLN1/Perspective_Image_2.jpg" alt="Macro succulent pattern with green and coral tones" className="w-full h-full object-cover" data-id="element-342" />
            </div>
            <div className="md:w-1/2 flex flex-col justify-center" data-id="element-343">
              <h2 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-1" data-id="element-344">
                Meet Huwey.
              </h2>
              <p className="font-inter text-sm italic mb-4" style={{
              color: '#DB7261'
            }} data-id="element-345">
                Patent Pending
              </p>
              <div className="space-y-4" data-id="element-346">
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-347">
                  Huwey helps make sense of the clues your people are dropping.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-348">
                  Think of Huwey as a translator, but for feelings, not phrases.
                  It's an analytics tool (souped up by AI) that takes the
                  unstructured feedback you already have and turns it into
                  insight you can actually use. Trained in psychology,
                  behavioral science, systems thinking, and more, Huwey shows
                  you how people feel, why they feel that way, and what you can
                  do about it.
                </p>
              </div>
            </div>
          </div>
        </Section>
        {/* Operations Section */}
        <Section data-id="element-349">
          <SectionHeader title="How it works." description="Huwey takes the unstructured data you already have from internal surveys, focus groups and interviews and structures it to help you better understand, empathize and prioritize." centered data-id="element-350" />
          <div className="max-w-5xl mx-auto" data-id="element-351">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16" data-id="element-352">
              <OperationsCard icon="https://uploadthingy.s3.us-west-1.amazonaws.com/n5jZtsFPzqm44vECNJQNf8/Perception.png" title="Understand Perception" description="Perception is reality. It's also personal, so its easy to misunderstand. Huwey takes your existing data (think engagement surveys, NPS, partner feedback, pulse surveys, and more) and surfaces the positive and negative perceptions shaping how people show up and decide." data-id="element-353" />
              <OperationsCard icon="https://uploadthingy.s3.us-west-1.amazonaws.com/j8TFDpFrLNwV6JRRaVDxep/Driver.png" title="Diagnose Drivers" description="Not all problems are what they seem. A back-to-office gripe might be about infrastructure. A career complaint could be about fairness. Huwey reads between the lines (analyzing language, emotion, and context) to uncover the real drivers behind behavior, so you can fix the root, not the reaction." data-id="element-354" />
              <OperationsCard icon="https://uploadthingy.s3.us-west-1.amazonaws.com/gQnoqot2XaLCa93mMb3LCP/Impact.png" title="Prioritize Impact" description="When resources are tight, misalignment gets expensive. Too often, teams spend time and money fixing what looks broken, only to realize they missed what is. Huwey shows you which issues are creating the most friction (or value), so you can focus energy and investments where it'll really move the needle." data-id="element-355" />
            </div>
          </div>
        </Section>
        {/* Use Case Section 1 */}
        <Section bgColor="lightgray" data-id="element-356">
          <div className="flex flex-col md:flex-row md:gap-16 lg:gap-32" data-id="element-357">
            <div className="mb-8 md:mb-0 md:w-1/2 bg-white overflow-hidden rounded-lg flex items-center justify-center aspect-[4/3]" data-id="element-358">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oLUWJ4qK649Tbdb9WPgGky/Perspective_Image_3.jpg" alt="Geometric architectural pattern with teal glass and white structural elements" className="w-full h-full object-cover" data-id="element-359" />
            </div>
            <div className="md:w-1/2 flex flex-col justify-center" data-id="element-360">
              <h2 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-4" data-id="element-361">
                Made for the people behind the metrics.
              </h2>
              <div className="space-y-4" data-id="element-362">
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-363">
                  Work doesn't get done in a vacuum. It happens in a constantly
                  shifting ecosystem of employees, customers, and partners. And
                  as that system shifts to meet mounting expectations, your
                  approach needs to shift with it.
                </p>
                <p className="font-inter text-base leading-relaxed text-black" data-id="element-364">
                  If it doesn't, you don't just risk losing employee engagement.
                  You risk losing the customer and partner relationships that
                  rely on it. Huwey helps you stay ahead of change, whether it's
                  planned or unexpected, by surfacing the real signals behind
                  sentiment.
                </p>
              </div>
            </div>
          </div>
        </Section>
        {/* Use Case Section 2 with Accordion */}
        <Section data-id="element-365">
          <div className="flex flex-col md:flex-row md:gap-16 lg:gap-32" data-id="element-366">
            <div className="mb-8 md:mb-0 md:w-1/2" data-id="element-367">
              <h2 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-6" data-id="element-368">
                Use cases
              </h2>
              <UseCaseAccordion items={accordionItems} data-id="element-369" />
            </div>
            <div className="md:w-1/2 bg-lightgray aspect-[4/3] rounded-lg flex items-center justify-center" data-id="element-370">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mxEUJ35qouosogT7C9kJmG/Perspective_Image_4.jpg" alt="Abstract flowing curves with coral and orange tones" className="w-full h-full object-cover" data-id="element-371" />
            </div>
          </div>
        </Section>
        {/* Closing Section */}
        <Section bgColor="lightgray" data-id="element-372">
          <div className="max-w-4xl mx-auto text-center" data-id="element-373">
            <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-374">
              See what Huwey can do.
            </h2>
            <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-375">
              Huwey helps you focus where it counts, on the perceptions that
              matter, the drivers behind them, and the decisions that drive
              results not drain resources. Reach out today to see what Huwey can
              do for you.
            </p>
          </div>
        </Section>
        {/* CTA Band */}
        <LimeBandCTA text="Ready to get started?" linkText="Let's Connect" href="#" data-id="element-376" />
      </main>
      <Footer data-id="element-377" />
    </div>;
}